import React from "react";

import { Space } from "antd";

import { ReportFormat } from "../../store/common_types";
import { DateRange, DateRangeSelector } from "../selectors";
import { ButtonsSection } from "../table";

import styles from "./styles.module.scss";

export interface PageHeaderProps {
  isLoading?: boolean;
  isReportDownloading?: boolean;
  reportDownloadDisabled?: boolean;

  onReload: () => void;
  onDownloadReport?: (reportFormat: ReportFormat) => void;

  dateRange?: DateRange;
  onDateRangeSelect?: (range: DateRange) => void;
}

export const PageHeader: React.FC<PageHeaderProps> = (props) => {
  const {
    isLoading,
    reportDownloadDisabled,
    onDateRangeSelect,
    onReload,
    dateRange,
    onDownloadReport,
    children,
  } = props;

  return (
    <div className={styles.wrapper}>
      <Space className={styles.left}>
        {dateRange && onDateRangeSelect && <DateRangeSelector range={dateRange} onSelect={onDateRangeSelect} />}
        {children}
      </Space>
      <ButtonsSection
        className={styles.right}
        loading={isLoading}
        onReload={onReload}
        onDownloadReport={onDownloadReport}
        reportDownloadDisabled={reportDownloadDisabled}
      />
    </div>
  );
};
